import React, { FunctionComponent } from 'react'
import { Path, Svg } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { tID } from '../../utils'

/**
 * Essentials Icon currently used on the bottom nav
 */
export const EssentialsIcon: FunctionComponent<EssentialsIconProps> = ({
  size = 24,
  fillColor,
  testID = 'EssentialsIcon',
}) => {
  const { colors } = useTheme()
  const { fill } = colors.icons.essentialsIcon

  return (
    <Svg testID={tID(testID)} width={size} height={size} viewBox='0 0 24 24' fill='none'>
      {
        <Path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M6.079 2.25h10.447c.967 0 1.75.784 1.75 1.75v1.38h.224c.966 0 1.75.784 1.75 1.75V19a2.75 2.75 0 01-2.75 2.75h-11a2.748 2.748 0 01-2.75-2.747V4.565c0-.524.134-.966.374-1.323.237-.352.547-.577.832-.718a2.702 2.702 0 011.08-.273h.026l.01-.001h.007V3v-.75zm.006 1.5l-.02.001a1.205 1.205 0 00-.442.117.635.635 0 00-.254.211c-.056.083-.119.228-.119.486 0 .259.063.403.12.487.058.088.144.157.253.21a1.205 1.205 0 00.462.118h10.691V4a.25.25 0 00-.25-.25H6.086zm.033 3.13h-.04v-.676.676H6.035l-.078-.005a2.702 2.702 0 01-.708-.145v12.273c0 .689.558 1.247 1.25 1.247h11c.69 0 1.25-.56 1.25-1.25V7.13a.25.25 0 00-.25-.25h-5.75v5.903a.75.75 0 01-1.043.69l-2.446-1.04-2.06 1.022a.75.75 0 01-1.083-.672V6.88zm1.5 0v4.694l1.286-.637a.75.75 0 01.626-.019l1.72.731V6.881H7.618z'
          fill={fillColor || fill}
        />
      }
    </Svg>
  )
}

type EssentialsIconProps = {
  size?: number | string
  fillColor?: string
  testID?: string
}
